/**
 * voice-v8 — Memory-API-Wrapper.
 *
 * Tag 10: dünner Fetch-Layer für /api/memory/{search,recent}.
 */

export type MemoryType =
  | "chat"
  | "fact"
  | "note"
  | "project"
  | "project_chapter"
  | "contact"
  | "preference"
  | "url"
  | "task";

export interface MemoryHit {
  id: string;
  type: MemoryType;
  content: string;
  tags: string[];
  createdAt: string;
  score?: number;
}

interface SearchResponse {
  query: string;
  hits: MemoryHit[];
}

interface RecentResponse {
  items: MemoryHit[];
}

interface MemoryQueryOptions {
  type?: MemoryType | "any";
  limit?: number;
  tags?: string[];
}

export async function searchMemory(
  query: string,
  opts: MemoryQueryOptions = {},
): Promise<MemoryHit[]> {
  const limit = opts.limit ?? 10;
  const params = new URLSearchParams({ q: query, limit: String(limit) });
  if (opts.type && opts.type !== "any") params.set("type", opts.type);
  if (opts.tags && opts.tags.length > 0)
    params.set("tags", opts.tags.join(","));
  const res = await fetch(`/api/memory/search?${params.toString()}`);
  if (!res.ok) throw new Error(`memory search failed: ${res.status}`);
  const data = (await res.json()) as SearchResponse;
  return data.hits;
}

export async function recentMemory(
  opts: MemoryQueryOptions = {},
): Promise<MemoryHit[]> {
  const limit = opts.limit ?? 30;
  const params = new URLSearchParams({ limit: String(limit) });
  if (opts.type && opts.type !== "any") params.set("type", opts.type);
  if (opts.tags && opts.tags.length > 0)
    params.set("tags", opts.tags.join(","));
  const res = await fetch(`/api/memory/recent?${params.toString()}`);
  if (!res.ok) throw new Error(`memory recent failed: ${res.status}`);
  const data = (await res.json()) as RecentResponse;
  return data.items;
}
